class CustomMultiColumnImages extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // If using shadow DOM, you'd move your innerHTML here.
        // Since your HTML is rendered via Liquid, we can work with light DOM.
        this.initImageToggle();
    }

    initImageToggle() {
        // Helper function to cycle images inside a container
        const cycleImages = (containerSelector, desktopClass, mobileClass) => {
            const container = this.querySelector(containerSelector);
            if (!container) return;

            container.addEventListener("click", (event) => {
                // Optional: only trigger if clicking the image itself
                if (!event.target.closest(`.${desktopClass}, .${mobileClass}`)) return;

                // Desktop images
                const desktopImages = container.querySelectorAll(`.${desktopClass}`);
                let activeDesktop = container.querySelector(`.${desktopClass}.active`);
                if (activeDesktop) {
                    activeDesktop.classList.remove("active");
                    let next = activeDesktop.nextElementSibling;
                    if (!next || !next.classList.contains(desktopClass)) {
                        next = desktopImages[0]; // loop back to first
                    }
                    next.classList.add("active");
                }

                // Mobile images
                const mobileImages = container.querySelectorAll(`.${mobileClass}`);
                let activeMobile = container.querySelector(`.${mobileClass}.active`);
                if (activeMobile) {
                    activeMobile.classList.remove("active");
                    let next = activeMobile.nextElementSibling;
                    if (!next || !next.classList.contains(mobileClass)) {
                        next = mobileImages[0]; // loop back to first
                    }
                    next.classList.add("active");
                }
            });
        };

        // Apply cycling for first and second image containers
        cycleImages(
            ".first-image-container",
            "first-desktop-image",
            "first-mobile--image"
        );

        cycleImages(
            ".second-image-container",
            "second-desktop--image",
            "second-mobile--image"
        );
    }
}

customElements.define('custom-multi-column-images', CustomMultiColumnImages);
